<template>
  <div :class="`col-sm-${colsm} col-md-${colmd}`">
    <!-- @click="$emit('on-attach', obj.id)" -->
    <div @click="$emit('on-attach', obj.id)" class="card card-file">
      <div v-if="!hideDrpDwn" class="dropdown-file" :class="{ show: activeId == obj.id }">
        <a
          @click.stop="$emit('on-dropdown', obj)"
          class="dropdown-link marker-icon marker-top-right marker-secondary pd-l-20 pd-t-5"
        >
          <feather type="more-vertical" class="text-white"></feather>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          :class="{ show: activeId == obj.id }"
        >
          <a class="dropdown-item details d-flex align-items-center">
            <feather type="info" class="mg-r-5 ht-20-f wd-20-f"></feather
            >Дэлгэрэнгүй
          </a>
          <a
            v-if="finder"
            @click.stop="$emit('on-link', fromCoreEdit ? obj : obj.id)"
            class="dropdown-item details d-flex align-items-center"
          >
            <feather type="link" class="mg-r-5 ht-20-f wd-20-f"></feather>Холбох
          </a>
          <a
            @click.stop="$emit('on-setting', obj)"
            class="dropdown-item details d-flex align-items-center"
          >
            <feather type="settings" class="mg-r-5 ht-20-f wd-20-f"></feather
            >Тохиргоо
          </a>
          <a
            v-if="!finder && boxId > 0"
            @click.stop="$emit('un-link', obj)"
            class="dropdown-item details d-flex align-items-center"
          >
            <feather type="x" class="mg-r-5 ht-20-f wd-20-f"></feather>Холболт
            салгах
          </a>
          <a
            @click.stop="$emit('on-delete', obj)"
            class="dropdown-item details d-flex align-items-center text-danger"
          >
            <feather
              type="trash-2"
              class="mg-r-5 ht-20-f wd-20-f text-danger"
            ></feather
            >Устгах
          </a>
        </div>
      </div>

      <div
        class="card-file-thumb"
        :class="{
          'tx-danger': obj.ext == 'pdf',
          'tx-primary': obj.ext == 'word',
          'tx-success': obj.ext == 'excel',
          'tx-orange': obj.ext == 'powerpoint',
          'tx-gray-600': obj.ext == 'alt'
        }"
      >
        <img
          v-if="obj.ext == 'image'"
          :src="`${obj.l}?w=198&h=120&mode=pad`"
          class="wd-100p ht-100p"
        />
        <img
          v-else-if="obj.ext == 'video' && finder"
          :src="`${obj.c}?w=198&h=120&mode=pad`"
          class="wd-100p ht-100p"
        />
        <i v-else :class="`far fa-file-${obj.ext}`"></i>
      </div>
      <div class="card-body">
        <h6>
          <a class="link-02" :title="obj.t">{{ obj.t }}</a>
        </h6>

        <div class="d-flex">
          <span>{{ obj.s }}</span>
          <span class="mg-l-auto">{{ obj.ex }}</span>
        </div>
      </div>
      <div class="card-footer d-flex">
        <span class="">{{ obj.dt | moment("YYYY.MM.DD HH:mm") }}</span>
        <span class="mg-l-auto">{{ obj.dt | moment("dddd") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeId: {
      type: Number,
      default: () => 0
    },
    colmd: {
      type: Number,
      default: () => 3
    },
    colsm: {
      type: Number,
      default: () => 4
    },
    obj: {
      type: Object,
      default: () => {}
    },
    finder: {
      type: Boolean,
      default: () => false
    },
    boxId: {
      type: Number,
      default: () => 0
    },
    fromCoreEdit: {
      type: Boolean,
      default: () => false
    },
    hideDrpDwn:{
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      activeDropdown: 0
    };
  },
  methods: {
    openDropdown(e) {
      this.activeDropdown = e.id;
    }
  }
};
</script>

<style></style>
